import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly ngxSpinnerSvc = inject(NgxSpinnerService);
  isLoading = new BehaviorSubject<boolean | null>(false);
  constructor() {}

  showSpinner(): void {
    this.isLoading.next(true);
    this.ngxSpinnerSvc.show();
  }

  hideSpinner(): void {
    this.ngxSpinnerSvc.hide();
    this.isLoading.next(false);
  }
}
